function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3011 0H3.68756C1.65422 0 0.00109912 1.61458 0.00109912 3.60417V46.3917C5.74741e-05 48.3833 1.65422 50 3.68756 50H46.3001C48.3386 50 49.998 48.3833 49.998 46.3917V3.60521C50.0001 1.61354 48.3396 0 46.3021 0H46.3011Z",
  fill: "#007BB5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.4094 18.7448H14.8323V42.6041H7.4094V18.7448ZM11.1229 6.8833C11.6957 6.87111 12.2652 6.97346 12.7979 7.18433C13.3306 7.39521 13.8158 7.71036 14.2251 8.11129C14.6343 8.51223 14.9594 8.99087 15.1811 9.51912C15.4029 10.0474 15.5169 10.6146 15.5165 11.1875C15.5161 11.7605 15.4013 12.3275 15.1787 12.8555C14.9562 13.3834 14.6304 13.8616 14.2206 14.2619C13.8108 14.6622 13.3251 14.9767 12.7921 15.1868C12.2591 15.3969 11.6895 15.4984 11.1167 15.4854C9.99239 15.4598 8.92278 14.995 8.13695 14.1906C7.35112 13.3861 6.91154 12.3059 6.91235 11.1813C6.91317 10.0567 7.35432 8.97711 8.14132 8.17378C8.92832 7.37044 9.9986 6.90721 11.1229 6.8833ZM19.4844 18.7448H26.5927V22.0062H26.6948C27.6844 20.1312 30.1032 18.152 33.7115 18.152C41.2198 18.152 42.6073 23.0927 42.6073 29.5198V42.6041H35.1927V31C35.1927 28.2333 35.1448 24.6739 31.3386 24.6739C27.4802 24.6739 26.8907 27.6895 26.8907 30.8031V42.6052H19.4844V18.7437V18.7448Z",
  fill: "white"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.328ffc84.svg";
export { ForwardRef as ReactComponent };